import { Table } from 'antd';
import React, { useEffect } from 'react'
import { useState } from 'react';
import ProgrammeService from '../../../api/programme.service';


const ProgrammeGroupList = () => {
    // const [visible, setVisible] = useState(false);
    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);
    const [programmeGroupList, setProgrammeGroupList] = useState([]);

    /*
    const [paymentModeData, setPaymentModeData] = useState({
        id: 0,
        payment_mode: '',
        account_id: '',
        mode: EDIT_MODE
    });
  
    const showDrawer = (rowdata) => {
    
    setPaymentModeData({
        id: rowdata.id,
        payment_mode: rowdata.payment_mode,
        account_id: rowdata.account_id,
        mode: EDIT_MODE
    })
  
      setVisible(true);
  
    };
  
  
    const onClose = () => {
      setVisible(false);
    };
  
  */
    
  
  
    const columns = [
      { 
        title: '#', 
        dataIndex: 'index', 
        render: (text, record, index) => (page - 1) * 10 + ++index ,
        width: '5%',
      },
      {
        title: 'Title',
        dataIndex: 'programme_group',
        key: 'programme_group',
        sorter: (a, b) => a.programme_group.localeCompare(b.programme_group),
      },
      /*
      {
        title: 'Action',
        key: 'action',
        render: (selectedObj) => (
          
          <Space size="middle">
            <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
          </Space>
        ),
      },
      */
    ];
  
  
    useEffect(() => {
        ProgrammeService.programmeGroupList().then((res) => {
            // console.log(res.data.response_data);
            setProgrammeGroupList(res.data.response_data);
        });
    }, [])
  
    return (
      <>
        <Table 
          columns={columns} 
          rowKey='programme_group_id' 
          dataSource={programmeGroupList}
          pagination={{
            showTotal,
            onChange(current) {
              setPage(current);
            }
          }}
          size='small'
        />
        {
            /*
        
        <Drawer
            title="Edit Payment Mode"
            width="478px"
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose = {true}
  
          >
            <PaymentModeEntry data={paymentModeData}/>
          </Drawer>
         */ }
  
      </>
    );
}

export default ProgrammeGroupList